import { apiSlice } from "./apiSlice";

export const resourceSyncApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getResourceRevisions: builder.query({
      query: () => "/api/resource-sync/revisions/",
      keepUnusedDataFor: 0,
    }),
  }),
});
